import { FC } from 'react';
import { SvgIconProps } from '@material-ui/core';
import { MobileFloatMenu } from './components/menu-item/styled';
import { MenuItem } from './components';

interface Item {
  title: string;
  icon: FC<SvgIconProps>;
  count?: number;
  onClick: () => void;
}

interface FloatMenuProps {
  items: Item[];
}

export const FloatMenu = ({ items }: FloatMenuProps) => (
  <MobileFloatMenu>
    {items.map(({ title, icon, count, onClick }) => (
      <MenuItem
        key={title}
        title={title}
        Icon={icon}
        onClick={onClick}
        count={count}
      />
    ))}
  </MobileFloatMenu>
);
